// Obtener la URL actual
var urlActual = window.location.href;

// Definir un objeto de mapeo para los dominios
var dominioMapping = {
    'pt.momabikes.com': 'momabikes.pt',
    'de.momabikes.com': 'momabikes.de',
    'it.momabikes.com': 'momabikes.it',
    'en.momabikes.com': 'momabikes.eu',
    // Agrega más dominios según sea necesario
};

// Función para cambiar el dominio
function cambiarDominio(url) {
    // Obtener el dominio actual
    var dominioActual = window.location.hostname;

    // Verificar si hay un mapeo para el dominio actual
    if (dominioMapping.hasOwnProperty(dominioActual)) {
        // Construir la nueva URL con el dominio cambiado
        var nuevoDominio = dominioMapping[dominioActual];
        var nuevaUrl = url.replace(dominioActual, nuevoDominio);

        // Redirigir a la nueva URL
        window.location.href = nuevaUrl;
    }
}

// Llamar a la función para cambiar el dominio
cambiarDominio(urlActual);
